//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.2.0.0 (NJsonSchema v11.1.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class PonderAuthClientBase {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param email (optional) 
     * @param username (optional) 
     * @return OK
     */
    accountReserve(email: string | undefined, username: string | undefined): Observable<AuthResponse> {
        let url_ = this.baseUrl + "/account/reserve?";
        if (email === null)
            throw new Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        if (username === null)
            throw new Error("The parameter 'username' cannot be null.");
        else if (username !== undefined)
            url_ += "username=" + encodeURIComponent("" + username) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAccountReserve(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAccountReserve(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthResponse>;
        }));
    }

    protected processAccountReserve(response: HttpResponseBase): Observable<AuthResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AuthResponse>(null as any);
    }

    /**
     * @return OK
     */
    accountConfirm(): Observable<AuthResponse> {
        let url_ = this.baseUrl + "/account/confirm";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAccountConfirm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAccountConfirm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthResponse>;
        }));
    }

    protected processAccountConfirm(response: HttpResponseBase): Observable<AuthResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AuthResponse>(null as any);
    }

    /**
     * @param username (optional) 
     * @return OK
     */
    accountDelete(username: string | undefined): Observable<AuthResponse> {
        let url_ = this.baseUrl + "/account/delete?";
        if (username === null)
            throw new Error("The parameter 'username' cannot be null.");
        else if (username !== undefined)
            url_ += "username=" + encodeURIComponent("" + username) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAccountDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAccountDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthResponse>;
        }));
    }

    protected processAccountDelete(response: HttpResponseBase): Observable<AuthResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AuthResponse>(null as any);
    }

    /**
     * @param username (optional) 
     * @return OK
     */
    accountRestore(username: string | undefined): Observable<AuthResponse> {
        let url_ = this.baseUrl + "/account/restore?";
        if (username === null)
            throw new Error("The parameter 'username' cannot be null.");
        else if (username !== undefined)
            url_ += "username=" + encodeURIComponent("" + username) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAccountRestore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAccountRestore(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthResponse>;
        }));
    }

    protected processAccountRestore(response: HttpResponseBase): Observable<AuthResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AuthResponse>(null as any);
    }

    /**
     * @return OK
     */
    accountUsername(body: UpdateUsernameRequest): Observable<AuthResponse> {
        let url_ = this.baseUrl + "/account/username";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAccountUsername(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAccountUsername(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthResponse>;
        }));
    }

    protected processAccountUsername(response: HttpResponseBase): Observable<AuthResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AuthResponse>(null as any);
    }

    /**
     * @return OK
     */
    index(): Observable<void> {
        let url_ = this.baseUrl + "/";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIndex(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIndex(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processIndex(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    health(): Observable<void> {
        let url_ = this.baseUrl + "/health";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHealth(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHealth(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processHealth(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    modify(body: ModifyPermissionsRequest): Observable<AuthResponse> {
        let url_ = this.baseUrl + "/modify";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processModify(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processModify(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthResponse>;
        }));
    }

    protected processModify(response: HttpResponseBase): Observable<AuthResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AuthResponse>(null as any);
    }

    /**
     * @param username (optional) 
     * @return OK
     */
    listRole(username: string | undefined): Observable<GetRoleResponse> {
        let url_ = this.baseUrl + "/list/role?";
        if (username === null)
            throw new Error("The parameter 'username' cannot be null.");
        else if (username !== undefined)
            url_ += "username=" + encodeURIComponent("" + username) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRoleResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRoleResponse>;
        }));
    }

    protected processListRole(response: HttpResponseBase): Observable<GetRoleResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRoleResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRoleResponse>(null as any);
    }

    /**
     * @param username (optional) 
     * @return OK
     */
    listPermission(username: string | undefined): Observable<GetPermissionsResponse> {
        let url_ = this.baseUrl + "/list/permission?";
        if (username === null)
            throw new Error("The parameter 'username' cannot be null.");
        else if (username !== undefined)
            url_ += "username=" + encodeURIComponent("" + username) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListPermission(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListPermission(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPermissionsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPermissionsResponse>;
        }));
    }

    protected processListPermission(response: HttpResponseBase): Observable<GetPermissionsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPermissionsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPermissionsResponse>(null as any);
    }

    /**
     * @param username (optional) 
     * @return OK
     */
    listRolePermission(username: string | undefined): Observable<GetRoleAndPermissionsResponse> {
        let url_ = this.baseUrl + "/list/role-permission?";
        if (username === null)
            throw new Error("The parameter 'username' cannot be null.");
        else if (username !== undefined)
            url_ += "username=" + encodeURIComponent("" + username) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListRolePermission(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListRolePermission(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRoleAndPermissionsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRoleAndPermissionsResponse>;
        }));
    }

    protected processListRolePermission(response: HttpResponseBase): Observable<GetRoleAndPermissionsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRoleAndPermissionsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRoleAndPermissionsResponse>(null as any);
    }

    /**
     * @param sortBy (optional) 
     * @param start (optional) 
     * @param count (optional) 
     * @param nameFilter (optional) 
     * @param emailFilter (optional) 
     * @return OK
     */
    listUsers(sortBy: SortBy | undefined, start: number | undefined, count: number | undefined, nameFilter: string | undefined, emailFilter: string | undefined): Observable<ListUsersResponse> {
        let url_ = this.baseUrl + "/list/users?";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (start === null)
            throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent("" + start) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        if (nameFilter === null)
            throw new Error("The parameter 'nameFilter' cannot be null.");
        else if (nameFilter !== undefined)
            url_ += "nameFilter=" + encodeURIComponent("" + nameFilter) + "&";
        if (emailFilter === null)
            throw new Error("The parameter 'emailFilter' cannot be null.");
        else if (emailFilter !== undefined)
            url_ += "emailFilter=" + encodeURIComponent("" + emailFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListUsersResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListUsersResponse>;
        }));
    }

    protected processListUsers(response: HttpResponseBase): Observable<ListUsersResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListUsersResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ListUsersResponse>(null as any);
    }

    /**
     * @param actionType (optional) 
     * @return OK
     */
    ulaRestriction(actionType: ActionType | undefined): Observable<GetUserLimitedActionRestrictionResponse> {
        let url_ = this.baseUrl + "/ula/restriction?";
        if (actionType === null)
            throw new Error("The parameter 'actionType' cannot be null.");
        else if (actionType !== undefined)
            url_ += "actionType=" + encodeURIComponent("" + actionType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUlaRestriction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUlaRestriction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserLimitedActionRestrictionResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserLimitedActionRestrictionResponse>;
        }));
    }

    protected processUlaRestriction(response: HttpResponseBase): Observable<GetUserLimitedActionRestrictionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserLimitedActionRestrictionResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUserLimitedActionRestrictionResponse>(null as any);
    }

    /**
     * @return OK
     */
    stripeEvent(): Observable<void> {
        let url_ = this.baseUrl + "/stripe/event";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStripeEvent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStripeEvent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processStripeEvent(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    subscriptionCreate(): Observable<CreateSubscriptionResponse> {
        let url_ = this.baseUrl + "/subscription/create";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubscriptionCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubscriptionCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateSubscriptionResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateSubscriptionResponse>;
        }));
    }

    protected processSubscriptionCreate(response: HttpResponseBase): Observable<CreateSubscriptionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateSubscriptionResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateSubscriptionResponse>(null as any);
    }

    /**
     * @param subscriptionId (optional) 
     * @param immediate (optional) 
     * @return OK
     */
    subscriptionCancel(subscriptionId: string | undefined, immediate: boolean | undefined): Observable<AuthResponse> {
        let url_ = this.baseUrl + "/subscription/cancel?";
        if (subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' cannot be null.");
        else if (subscriptionId !== undefined)
            url_ += "subscriptionId=" + encodeURIComponent("" + subscriptionId) + "&";
        if (immediate === null)
            throw new Error("The parameter 'immediate' cannot be null.");
        else if (immediate !== undefined)
            url_ += "immediate=" + encodeURIComponent("" + immediate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubscriptionCancel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubscriptionCancel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthResponse>;
        }));
    }

    protected processSubscriptionCancel(response: HttpResponseBase): Observable<AuthResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AuthResponse>(null as any);
    }

    /**
     * @return OK
     */
    subscriptionList(): Observable<GetSubscriptionsResponse> {
        let url_ = this.baseUrl + "/subscription/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubscriptionList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubscriptionList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSubscriptionsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSubscriptionsResponse>;
        }));
    }

    protected processSubscriptionList(response: HttpResponseBase): Observable<GetSubscriptionsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSubscriptionsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSubscriptionsResponse>(null as any);
    }

    /**
     * @return OK
     */
    subscriptionPaymentMethodList(): Observable<GetPaymentMethodsResponse> {
        let url_ = this.baseUrl + "/subscription/payment-method/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubscriptionPaymentMethodList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubscriptionPaymentMethodList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPaymentMethodsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPaymentMethodsResponse>;
        }));
    }

    protected processSubscriptionPaymentMethodList(response: HttpResponseBase): Observable<GetPaymentMethodsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPaymentMethodsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPaymentMethodsResponse>(null as any);
    }

    /**
     * @param paymentMethodId (optional) 
     * @return OK
     */
    subscriptionPaymentMethodDelete(paymentMethodId: string | undefined): Observable<AuthResponse> {
        let url_ = this.baseUrl + "/subscription/payment-method/delete?";
        if (paymentMethodId === null)
            throw new Error("The parameter 'paymentMethodId' cannot be null.");
        else if (paymentMethodId !== undefined)
            url_ += "paymentMethodId=" + encodeURIComponent("" + paymentMethodId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubscriptionPaymentMethodDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubscriptionPaymentMethodDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthResponse>;
        }));
    }

    protected processSubscriptionPaymentMethodDelete(response: HttpResponseBase): Observable<AuthResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AuthResponse>(null as any);
    }

    /**
     * @return OK
     */
    subscriptionRenew(body: RenewSubscriptionRequest): Observable<AuthResponse> {
        let url_ = this.baseUrl + "/subscription/renew";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubscriptionRenew(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubscriptionRenew(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthResponse>;
        }));
    }

    protected processSubscriptionRenew(response: HttpResponseBase): Observable<AuthResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AuthResponse>(null as any);
    }

    /**
     * @return OK
     */
    subscriptionCheckoutSession(): Observable<GetCheckoutSessionResponse> {
        let url_ = this.baseUrl + "/subscription/checkout-session";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubscriptionCheckoutSession(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubscriptionCheckoutSession(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCheckoutSessionResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCheckoutSessionResponse>;
        }));
    }

    protected processSubscriptionCheckoutSession(response: HttpResponseBase): Observable<GetCheckoutSessionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCheckoutSessionResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCheckoutSessionResponse>(null as any);
    }

    /**
     * @return OK
     */
    validate(): Observable<ValidateResponse> {
        let url_ = this.baseUrl + "/validate";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ValidateResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ValidateResponse>;
        }));
    }

    protected processValidate(response: HttpResponseBase): Observable<ValidateResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValidateResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ValidateResponse>(null as any);
    }
}

export class AuthResponse implements IAuthResponse {
    success!: boolean;
    error?: string | undefined;

    [key: string]: any;

    constructor(data?: IAuthResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.success = _data["success"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): AuthResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuthResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["success"] = this.success;
        data["error"] = this.error;
        return data;
    }
}

export interface IAuthResponse {
    success: boolean;
    error?: string | undefined;

    [key: string]: any;
}

export class CreateSubscriptionResponse implements ICreateSubscriptionResponse {
    stripe?: CreateSubscriptionResponse2 | undefined;
    success!: boolean;
    error?: string | undefined;

    [key: string]: any;

    constructor(data?: ICreateSubscriptionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.stripe = _data["stripe"] ? CreateSubscriptionResponse2.fromJS(_data["stripe"]) : <any>undefined;
            this.success = _data["success"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): CreateSubscriptionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSubscriptionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["stripe"] = this.stripe ? this.stripe.toJSON() : <any>undefined;
        data["success"] = this.success;
        data["error"] = this.error;
        return data;
    }
}

export interface ICreateSubscriptionResponse {
    stripe?: CreateSubscriptionResponse2 | undefined;
    success: boolean;
    error?: string | undefined;

    [key: string]: any;
}

export class CreateSubscriptionResponse2 implements ICreateSubscriptionResponse2 {
    id?: string | undefined;
    type?: string | undefined;
    clientSecret?: string | undefined;
    error?: string | undefined;

    [key: string]: any;

    constructor(data?: ICreateSubscriptionResponse2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.type = _data["type"];
            this.clientSecret = _data["clientSecret"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): CreateSubscriptionResponse2 {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSubscriptionResponse2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["type"] = this.type;
        data["clientSecret"] = this.clientSecret;
        data["error"] = this.error;
        return data;
    }
}

export interface ICreateSubscriptionResponse2 {
    id?: string | undefined;
    type?: string | undefined;
    clientSecret?: string | undefined;
    error?: string | undefined;

    [key: string]: any;
}

export class CreditCard implements ICreditCard {
    brand!: string;
    country!: string;
    expirationMonth!: number;
    expirationYear!: number;
    lastFourDigits!: string;

    [key: string]: any;

    constructor(data?: ICreditCard) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.brand = _data["brand"];
            this.country = _data["country"];
            this.expirationMonth = _data["expirationMonth"];
            this.expirationYear = _data["expirationYear"];
            this.lastFourDigits = _data["lastFourDigits"];
        }
    }

    static fromJS(data: any): CreditCard {
        data = typeof data === 'object' ? data : {};
        let result = new CreditCard();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["brand"] = this.brand;
        data["country"] = this.country;
        data["expirationMonth"] = this.expirationMonth;
        data["expirationYear"] = this.expirationYear;
        data["lastFourDigits"] = this.lastFourDigits;
        return data;
    }
}

export interface ICreditCard {
    brand: string;
    country: string;
    expirationMonth: number;
    expirationYear: number;
    lastFourDigits: string;

    [key: string]: any;
}

export class GetCheckoutSessionResponse implements IGetCheckoutSessionResponse {
    id?: string | undefined;
    success!: boolean;
    error?: string | undefined;

    [key: string]: any;

    constructor(data?: IGetCheckoutSessionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.success = _data["success"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): GetCheckoutSessionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCheckoutSessionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["success"] = this.success;
        data["error"] = this.error;
        return data;
    }
}

export interface IGetCheckoutSessionResponse {
    id?: string | undefined;
    success: boolean;
    error?: string | undefined;

    [key: string]: any;
}

export class GetPaymentMethodsResponse implements IGetPaymentMethodsResponse {
    paymentMethods?: PaymentMethod[] | undefined;
    success!: boolean;
    error?: string | undefined;

    [key: string]: any;

    constructor(data?: IGetPaymentMethodsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["paymentMethods"])) {
                this.paymentMethods = [] as any;
                for (let item of _data["paymentMethods"])
                    this.paymentMethods!.push(PaymentMethod.fromJS(item));
            }
            this.success = _data["success"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): GetPaymentMethodsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPaymentMethodsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.paymentMethods)) {
            data["paymentMethods"] = [];
            for (let item of this.paymentMethods)
                data["paymentMethods"].push(item.toJSON());
        }
        data["success"] = this.success;
        data["error"] = this.error;
        return data;
    }
}

export interface IGetPaymentMethodsResponse {
    paymentMethods?: PaymentMethod[] | undefined;
    success: boolean;
    error?: string | undefined;

    [key: string]: any;
}

export class GetPermissionsResponse implements IGetPermissionsResponse {
    permissions?: UserPermissionType[] | undefined;
    success!: boolean;
    error?: string | undefined;

    [key: string]: any;

    constructor(data?: IGetPermissionsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
            this.success = _data["success"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): GetPermissionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPermissionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        data["success"] = this.success;
        data["error"] = this.error;
        return data;
    }
}

export interface IGetPermissionsResponse {
    permissions?: UserPermissionType[] | undefined;
    success: boolean;
    error?: string | undefined;

    [key: string]: any;
}

export class GetRoleAndPermissionsResponse implements IGetRoleAndPermissionsResponse {
    role?: NullableOfUserRoleType | undefined;
    permissions?: UserPermissionType[] | undefined;
    resourceLimits?: ResourceLimits | undefined;
    success!: boolean;
    error?: string | undefined;

    [key: string]: any;

    constructor(data?: IGetRoleAndPermissionsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.role = _data["role"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
            this.resourceLimits = _data["resourceLimits"] ? ResourceLimits.fromJS(_data["resourceLimits"]) : <any>undefined;
            this.success = _data["success"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): GetRoleAndPermissionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetRoleAndPermissionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["role"] = this.role;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        data["resourceLimits"] = this.resourceLimits ? this.resourceLimits.toJSON() : <any>undefined;
        data["success"] = this.success;
        data["error"] = this.error;
        return data;
    }
}

export interface IGetRoleAndPermissionsResponse {
    role?: NullableOfUserRoleType | undefined;
    permissions?: UserPermissionType[] | undefined;
    resourceLimits?: ResourceLimits | undefined;
    success: boolean;
    error?: string | undefined;

    [key: string]: any;
}

export class GetRoleResponse implements IGetRoleResponse {
    role?: NullableOfUserRoleType | undefined;
    success!: boolean;
    error?: string | undefined;

    [key: string]: any;

    constructor(data?: IGetRoleResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.role = _data["role"];
            this.success = _data["success"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): GetRoleResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetRoleResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["role"] = this.role;
        data["success"] = this.success;
        data["error"] = this.error;
        return data;
    }
}

export interface IGetRoleResponse {
    role?: NullableOfUserRoleType | undefined;
    success: boolean;
    error?: string | undefined;

    [key: string]: any;
}

export class GetSubscriptionsResponse implements IGetSubscriptionsResponse {
    subscriptions?: Subscription[] | undefined;
    success!: boolean;
    error?: string | undefined;

    [key: string]: any;

    constructor(data?: IGetSubscriptionsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["subscriptions"])) {
                this.subscriptions = [] as any;
                for (let item of _data["subscriptions"])
                    this.subscriptions!.push(Subscription.fromJS(item));
            }
            this.success = _data["success"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): GetSubscriptionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSubscriptionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.subscriptions)) {
            data["subscriptions"] = [];
            for (let item of this.subscriptions)
                data["subscriptions"].push(item.toJSON());
        }
        data["success"] = this.success;
        data["error"] = this.error;
        return data;
    }
}

export interface IGetSubscriptionsResponse {
    subscriptions?: Subscription[] | undefined;
    success: boolean;
    error?: string | undefined;

    [key: string]: any;
}

export class GetUserLimitedActionRestrictionResponse implements IGetUserLimitedActionRestrictionResponse {
    action?: NullableOfUserLimitedActionType | undefined;
    restrictionWindow?: NullableOfUserLimitedActionRestrictionType | undefined;
    restrictionCount?: number | undefined;
    success!: boolean;
    error?: string | undefined;

    [key: string]: any;

    constructor(data?: IGetUserLimitedActionRestrictionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.action = _data["action"];
            this.restrictionWindow = _data["restrictionWindow"];
            this.restrictionCount = _data["restrictionCount"];
            this.success = _data["success"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): GetUserLimitedActionRestrictionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserLimitedActionRestrictionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["action"] = this.action;
        data["restrictionWindow"] = this.restrictionWindow;
        data["restrictionCount"] = this.restrictionCount;
        data["success"] = this.success;
        data["error"] = this.error;
        return data;
    }
}

export interface IGetUserLimitedActionRestrictionResponse {
    action?: NullableOfUserLimitedActionType | undefined;
    restrictionWindow?: NullableOfUserLimitedActionRestrictionType | undefined;
    restrictionCount?: number | undefined;
    success: boolean;
    error?: string | undefined;

    [key: string]: any;
}

export class JwtAppMetadata implements IJwtAppMetadata {
    provider!: string;

    [key: string]: any;

    constructor(data?: IJwtAppMetadata) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.provider = _data["provider"];
        }
    }

    static fromJS(data: any): JwtAppMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new JwtAppMetadata();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["provider"] = this.provider;
        return data;
    }
}

export interface IJwtAppMetadata {
    provider: string;

    [key: string]: any;
}

export class JwtPayload implements IJwtPayload {
    exp!: number;
    iat!: number;
    iss!: string;
    sub!: string | undefined;
    email!: string | undefined;
    role!: string | undefined;
    app_metadata!: JwtAppMetadata;
    user_metadata!: JwtUserMetadata;

    [key: string]: any;

    constructor(data?: IJwtPayload) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.app_metadata = new JwtAppMetadata();
            this.user_metadata = new JwtUserMetadata();
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.exp = _data["exp"];
            this.iat = _data["iat"];
            this.iss = _data["iss"];
            this.sub = _data["sub"];
            this.email = _data["email"];
            this.role = _data["role"];
            this.app_metadata = _data["app_metadata"] ? JwtAppMetadata.fromJS(_data["app_metadata"]) : new JwtAppMetadata();
            this.user_metadata = _data["user_metadata"] ? JwtUserMetadata.fromJS(_data["user_metadata"]) : new JwtUserMetadata();
        }
    }

    static fromJS(data: any): JwtPayload {
        data = typeof data === 'object' ? data : {};
        let result = new JwtPayload();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["exp"] = this.exp;
        data["iat"] = this.iat;
        data["iss"] = this.iss;
        data["sub"] = this.sub;
        data["email"] = this.email;
        data["role"] = this.role;
        data["app_metadata"] = this.app_metadata ? this.app_metadata.toJSON() : <any>undefined;
        data["user_metadata"] = this.user_metadata ? this.user_metadata.toJSON() : <any>undefined;
        return data;
    }
}

export interface IJwtPayload {
    exp: number;
    iat: number;
    iss: string;
    sub: string | undefined;
    email: string | undefined;
    role: string | undefined;
    app_metadata: JwtAppMetadata;
    user_metadata: JwtUserMetadata;

    [key: string]: any;
}

export class JwtUserMetadata implements IJwtUserMetadata {
    email!: string;
    email_verified!: boolean;
    username!: string;

    [key: string]: any;

    constructor(data?: IJwtUserMetadata) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.email = _data["email"];
            this.email_verified = _data["email_verified"];
            this.username = _data["username"];
        }
    }

    static fromJS(data: any): JwtUserMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new JwtUserMetadata();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["email"] = this.email;
        data["email_verified"] = this.email_verified;
        data["username"] = this.username;
        return data;
    }
}

export interface IJwtUserMetadata {
    email: string;
    email_verified: boolean;
    username: string;

    [key: string]: any;
}

export class ListUsersResponse implements IListUsersResponse {
    users?: UserRoleAndPermissions[] | undefined;
    start?: number | undefined;
    totalUsers?: number | undefined;
    success!: boolean;
    error?: string | undefined;

    [key: string]: any;

    constructor(data?: IListUsersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(UserRoleAndPermissions.fromJS(item));
            }
            this.start = _data["start"];
            this.totalUsers = _data["totalUsers"];
            this.success = _data["success"];
            this.error = _data["error"];
        }
    }

    static fromJS(data: any): ListUsersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ListUsersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item.toJSON());
        }
        data["start"] = this.start;
        data["totalUsers"] = this.totalUsers;
        data["success"] = this.success;
        data["error"] = this.error;
        return data;
    }
}

export interface IListUsersResponse {
    users?: UserRoleAndPermissions[] | undefined;
    start?: number | undefined;
    totalUsers?: number | undefined;
    success: boolean;
    error?: string | undefined;

    [key: string]: any;
}

export class ModifyPermissionsRequest implements IModifyPermissionsRequest {
    username!: string;
    roleChange?: NullableOfUserRoleType | undefined;
    grantedPermissions?: UserPermissionType[] | undefined;
    revokedPermissions?: UserPermissionType[] | undefined;

    [key: string]: any;

    constructor(data?: IModifyPermissionsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.username = _data["username"];
            this.roleChange = _data["roleChange"];
            if (Array.isArray(_data["grantedPermissions"])) {
                this.grantedPermissions = [] as any;
                for (let item of _data["grantedPermissions"])
                    this.grantedPermissions!.push(item);
            }
            if (Array.isArray(_data["revokedPermissions"])) {
                this.revokedPermissions = [] as any;
                for (let item of _data["revokedPermissions"])
                    this.revokedPermissions!.push(item);
            }
        }
    }

    static fromJS(data: any): ModifyPermissionsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ModifyPermissionsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["username"] = this.username;
        data["roleChange"] = this.roleChange;
        if (Array.isArray(this.grantedPermissions)) {
            data["grantedPermissions"] = [];
            for (let item of this.grantedPermissions)
                data["grantedPermissions"].push(item);
        }
        if (Array.isArray(this.revokedPermissions)) {
            data["revokedPermissions"] = [];
            for (let item of this.revokedPermissions)
                data["revokedPermissions"].push(item);
        }
        return data;
    }
}

export interface IModifyPermissionsRequest {
    username: string;
    roleChange?: NullableOfUserRoleType | undefined;
    grantedPermissions?: UserPermissionType[] | undefined;
    revokedPermissions?: UserPermissionType[] | undefined;

    [key: string]: any;
}

export enum NullableOfUserLimitedActionRestrictionType {
    PerMinute = "PerMinute",
    PerHour = "PerHour",
    Per6Hours = "Per6Hours",
    Per12Hours = "Per12Hours",
    Per24Hours = "Per24Hours",
}

export enum NullableOfUserLimitedActionType {
    ImportCollection = "ImportCollection",
    ExportCollection = "ExportCollection",
    ChangeUsername = "ChangeUsername",
}

export enum NullableOfUserRoleType {
    None = "None",
    User = "User",
    UserPlus = "UserPlus",
    Moderator = "Moderator",
    Administrator = "Administrator",
}

export class PaymentMethod implements IPaymentMethod {
    id!: string;
    processor!: PaymentProcessor;
    creditCard?: CreditCard | undefined;

    [key: string]: any;

    constructor(data?: IPaymentMethod) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.processor = _data["processor"];
            this.creditCard = _data["creditCard"] ? CreditCard.fromJS(_data["creditCard"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PaymentMethod {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentMethod();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["processor"] = this.processor;
        data["creditCard"] = this.creditCard ? this.creditCard.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPaymentMethod {
    id: string;
    processor: PaymentProcessor;
    creditCard?: CreditCard | undefined;

    [key: string]: any;
}

export enum PaymentProcessor {
    None = "None",
    Stripe = "Stripe",
}

export enum PonderProductType {
    None = "None",
    UserPlusMonthlyMembership = "UserPlusMonthlyMembership",
}

export class RenewSubscriptionRequest implements IRenewSubscriptionRequest {
    subscriptionId!: string;

    [key: string]: any;

    constructor(data?: IRenewSubscriptionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.subscriptionId = _data["subscriptionId"];
        }
    }

    static fromJS(data: any): RenewSubscriptionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RenewSubscriptionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["subscriptionId"] = this.subscriptionId;
        return data;
    }
}

export interface IRenewSubscriptionRequest {
    subscriptionId: string;

    [key: string]: any;
}

export class ResourceLimits implements IResourceLimits {
    uniqueCollectedCount!: number;
    deckCount!: number;

    [key: string]: any;

    constructor(data?: IResourceLimits) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.uniqueCollectedCount = _data["uniqueCollectedCount"];
            this.deckCount = _data["deckCount"];
        }
    }

    static fromJS(data: any): ResourceLimits {
        data = typeof data === 'object' ? data : {};
        let result = new ResourceLimits();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["uniqueCollectedCount"] = this.uniqueCollectedCount;
        data["deckCount"] = this.deckCount;
        return data;
    }
}

export interface IResourceLimits {
    uniqueCollectedCount: number;
    deckCount: number;

    [key: string]: any;
}

export class Subscription implements ISubscription {
    id!: string;
    product!: PonderProductType;
    startedAt!: Date;
    endedAt?: Date | undefined;
    status?: SubscriptionStatus;

    [key: string]: any;

    constructor(data?: ISubscription) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.product = _data["product"];
            this.startedAt = _data["startedAt"] ? new Date(_data["startedAt"].toString()) : <any>undefined;
            this.endedAt = _data["endedAt"] ? new Date(_data["endedAt"].toString()) : <any>undefined;
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): Subscription {
        data = typeof data === 'object' ? data : {};
        let result = new Subscription();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["product"] = this.product;
        data["startedAt"] = this.startedAt ? this.startedAt.toISOString() : <any>undefined;
        data["endedAt"] = this.endedAt ? this.endedAt.toISOString() : <any>undefined;
        data["status"] = this.status;
        return data;
    }
}

export interface ISubscription {
    id: string;
    product: PonderProductType;
    startedAt: Date;
    endedAt?: Date | undefined;
    status?: SubscriptionStatus;

    [key: string]: any;
}

export enum SubscriptionStatus {
    Active = "Active",
    Pending = "Pending",
    Cancelled = "Cancelled",
    Inactive = "Inactive",
}

export class UpdateUsernameRequest implements IUpdateUsernameRequest {
    username!: string;

    [key: string]: any;

    constructor(data?: IUpdateUsernameRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.username = _data["username"];
        }
    }

    static fromJS(data: any): UpdateUsernameRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUsernameRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["username"] = this.username;
        return data;
    }
}

export interface IUpdateUsernameRequest {
    username: string;

    [key: string]: any;
}

export class User implements IUser {
    id!: string;
    createdAt!: Date;
    username!: string;
    displayName?: string | undefined;
    email?: string | undefined;
    status!: UserStatusType;

    [key: string]: any;

    constructor(data?: IUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.username = _data["username"];
            this.displayName = _data["displayName"];
            this.email = _data["email"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["username"] = this.username;
        data["displayName"] = this.displayName;
        data["email"] = this.email;
        data["status"] = this.status;
        return data;
    }
}

export interface IUser {
    id: string;
    createdAt: Date;
    username: string;
    displayName?: string | undefined;
    email?: string | undefined;
    status: UserStatusType;

    [key: string]: any;
}

export enum UserPermissionType {
    AddItem = "AddItem",
    AddItemPlus = "AddItemPlus",
    ImportCollection = "ImportCollection",
    ImportCollectionPlus = "ImportCollectionPlus",
    ImportDeck = "ImportDeck",
    ImportDeckPlus = "ImportDeckPlus",
    ViewAdminConsole = "ViewAdminConsole",
    ViewUsersList = "ViewUsersList",
    EditUserPermissions = "EditUserPermissions",
    ViewTasks = "ViewTasks",
    RunTasks = "RunTasks",
    FlagItem = "FlagItem",
    Comment = "Comment",
    ModerateComment = "ModerateComment",
    EditProfile = "EditProfile",
    ModerateProfile = "ModerateProfile",
    NoAds = "NoAds",
    AddDeck = "AddDeck",
    AddDeckPlus = "AddDeckPlus",
    EditMagic = "EditMagic",
    UploadArtifact = "UploadArtifact",
    DownloadArtifact = "DownloadArtifact",
    DeleteAccount = "DeleteAccount",
    ExportCollection = "ExportCollection",
    PostNews = "PostNews",
    CustomProfilePicture = "CustomProfilePicture",
}

export class UserRoleAndPermissions implements IUserRoleAndPermissions {
    user!: User;
    role!: UserRoleType;
    permissions!: UserPermissionType[];

    [key: string]: any;

    constructor(data?: IUserRoleAndPermissions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.user = new User();
            this.permissions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.user = _data["user"] ? User.fromJS(_data["user"]) : new User();
            this.role = _data["role"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
        }
    }

    static fromJS(data: any): UserRoleAndPermissions {
        data = typeof data === 'object' ? data : {};
        let result = new UserRoleAndPermissions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["role"] = this.role;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        return data;
    }
}

export interface IUserRoleAndPermissions {
    user: User;
    role: UserRoleType;
    permissions: UserPermissionType[];

    [key: string]: any;
}

export enum UserRoleType {
    None = "None",
    User = "User",
    UserPlus = "UserPlus",
    Moderator = "Moderator",
    Administrator = "Administrator",
}

export enum UserStatusType {
    Active = "Active",
    Inactive = "Inactive",
    Deleted = "Deleted",
}

export class ValidateResponse implements IValidateResponse {
    isValid!: boolean;
    jwtPayload?: JwtPayload | undefined;

    [key: string]: any;

    constructor(data?: IValidateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.isValid = _data["isValid"];
            this.jwtPayload = _data["jwtPayload"] ? JwtPayload.fromJS(_data["jwtPayload"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ValidateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["isValid"] = this.isValid;
        data["jwtPayload"] = this.jwtPayload ? this.jwtPayload.toJSON() : <any>undefined;
        return data;
    }
}

export interface IValidateResponse {
    isValid: boolean;
    jwtPayload?: JwtPayload | undefined;

    [key: string]: any;
}

export enum SortBy {
    JoinDate = "JoinDate",
    Username = "Username",
    EmailAddress = "EmailAddress",
    Role = "Role",
}

export enum ActionType {
    ImportCollection = "ImportCollection",
    ExportCollection = "ExportCollection",
    ChangeUsername = "ChangeUsername",
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}